// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27 fill=%27%23666%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-main-div-header {
  position: relative;
  z-index: 1;
}
.label-main-div-header .filter-group label {
  display: block;
  margin-bottom: 8px;
}
.label-main-div-header .view-toggle-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.label-main-div-header .view-toggle-wrapper .view-toggle-btn {
  display: flex;
  align-items: center;
  padding: 0.3rem 0.6rem;
  font-size: 0.9rem;
  background-color: transparent;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}
.label-main-div-header .view-toggle-wrapper .view-toggle-btn svg {
  font-size: 1rem;
}
.label-main-div-header .view-toggle-wrapper .view-toggle-btn.active {
  background-color: #e5e7eb;
}
.label-main-div-header .view-toggle-wrapper .view-toggle-btn:hover {
  background-color: #f3f4f6;
}
.label-main-div-header .label-mod {
  display: flex;
  gap: 8px;
}
.label-main-div-header .labels-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px var(--shadow-light);
}
.label-main-div-header .labels-table thead {
  background-color: #f1f5f9;
}
.label-main-div-header .labels-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
}
.label-main-div-header .labels-table tbody tr {
  transition: background-color 0.2s ease;
}
.label-main-div-header .labels-table tbody tr:hover {
  background-color: #f9fafb;
}
.label-main-div-header .labels-table tbody tr td {
  padding: 0.9rem 1rem;
}
.label-main-div-header .labels-table tbody tr td:last-child {
  white-space: nowrap;
}
.label-main-div-header .labels-table tbody tr td:last-child button {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  cursor: pointer;
}
.label-main-div-header .labels-table tbody tr td:last-child button:hover {
  opacity: 0.9;
  background-color: #fef9fa;
}
.label-main-div-header .label-container {
  margin-top: 1rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  background-color: #f8f9fa;
  padding: 1rem;
  grid-auto-rows: 1fr;
}
.label-main-div-header .label-container .no-labels-found {
  text-align: center;
  font-size: 1.1rem;
  color: var(--text-color-medium);
  padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);
  background: var(--card-bg);
  border-radius: 0.75rem;
  border: 1px dashed var(--border-color);
  box-shadow: 0 2px 5px var(--shadow-light);
  margin-top: calc(var(--spacing-unit) * 2);
  grid-column: 1/-1;
}
.label-main-div-header .label-container .label-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}
.label-main-div-header .label-container .label-card .label-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}
.label-main-div-header .label-container .label-card .label-card-header .label-title-section {
  flex: 1 1;
}
.label-main-div-header .label-container .label-card .label-card-header .label-title-section .label-name {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.5rem 0;
}
.label-main-div-header .label-container .label-card .label-card-header .label-title-section .label-meta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.label-main-div-header .label-container .label-card .label-card-header .label-title-section .label-meta .priority-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}
.label-main-div-header .label-container .label-card .label-card-header .label-title-section .label-meta .priority-badge.priority-high {
  background: #fef2f2;
  color: #dc2626;
}
.label-main-div-header .label-container .label-card .label-card-header .label-title-section .label-meta .priority-badge.priority-medium {
  background: #fef3c7;
  color: #d97706;
}
.label-main-div-header .label-container .label-card .label-card-header .label-title-section .label-meta .priority-badge.priority-low {
  background: #f0fdf4;
  color: #16a34a;
}
.label-main-div-header .label-container .label-card .label-card-header .label-title-section .label-meta .priority-badge.priority-unknown {
  background: #f3f4f6;
  color: #6b7280;
}
.label-main-div-header .label-container .label-card .label-card-header .label-title-section .label-meta .color-indicator {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 0 0 1px #e2e8f0;
}
.label-main-div-header .label-container .label-card .label-card-header .label-actions {
  display: flex;
  gap: 0.5rem;
}
.label-main-div-header .label-container .label-card .label-card-header .label-actions .action-btn {
  margin-right: 0.5rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.label-main-div-header .label-container .label-card .label-card-header .label-actions .action-btn:hover {
  background: var(--container-bg);
  opacity: 0.9;
}
.label-main-div-header .label-container .label-card .label-description {
  margin-bottom: 1rem;
}
.label-main-div-header .label-container .label-card .label-description p {
  color: #64748b;
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
}
.label-main-div-header .label-container .label-card .label-court-info {
  margin-bottom: 1rem;
}
.label-main-div-header .label-container .label-card .label-court-info .court-section {
  margin-bottom: 0.75rem;
}
.label-main-div-header .label-container .label-card .label-court-info .court-section .court-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}
.label-main-div-header .label-container .label-card .label-court-info .court-section .court-refs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.label-main-div-header .label-container .label-card .label-court-info .court-section .court-refs .court-ref-chip {
  background: #f1f5f9;
  color: #1e293b;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.label-main-div-header .label-container .label-card .label-court-info .court-section .court-refs .court-ref-chip:hover {
  background: #e2e8f0;
}
.label-main-div-header .label-container .label-card .label-footer {
  padding-top: 1rem;
  border-top: 1px solid #f1f5f9;
  margin-top: auto;
  min-height: 2rem;
}
.label-main-div-header .label-container .label-card .label-footer .created-date {
  color: #64748b;
  font-size: 0.75rem;
  line-height: 1.2;
}
.label-main-div-header .pagination-settings {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  padding: 7px 18px;
  background-color: #E2E8F0;
  border-radius: 6px;
}
.label-main-div-header .pagination-settings label {
  white-space: nowrap;
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}
.label-main-div-header .pagination-settings #labelPerPageSelect {
  border: none;
  border-radius: 6px;
  outline: none;
  padding: 6px 32px 6px 12px;
  background-color: white;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  min-width: 70px;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  transition: all 0.2s ease;
  box-shadow: none !important;
}
.label-main-div-header .pagination-settings #labelPerPageSelect:hover {
  background-color: #fafafa;
}
.label-main-div-header .pagination-settings #labelPerPageSelect:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  background-color: white;
}
.label-main-div-header .pagination-settings #labelPerPageSelect option {
  border: none !important;
  outline: none;
  padding: 4px 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Labels/Label.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;AACF;AACE;EACE,cAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAAN;AAEM;EACE,eAAA;AAAR;AAGM;EACE,yBAAA;AADR;AAIM;EACE,yBAAA;AAFR;AAME;EACE,aAAA;EACA,QAAA;AAJJ;AAQE;EACE,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AANJ;AAQI;EACE,yBAAA;AANN;AAQM;EACE,gBAAA;EACA,aAAA;EACA,cAAA;AANR;AAYM;EACE,sCAAA;AAVR;AAYQ;EACE,yBAAA;AAVV;AAaQ;EACE,oBAAA;AAXV;AAeQ;EACE,mBAAA;AAbV;AAeU;EACE,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;AAbZ;AAqBY;EACE,YAAA;EACA,yBAAA;AAnBd;AA2BE;EACE,gBAAA;EACA,aAAA;EACA,SAAA;EACA,2DAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAzBJ;AA4BI;EACE,kBAAA;EACM,iBAAA;EACA,+BAAA;EACA,oEAAA;EACA,0BAAA;EACA,sBAAA;EACA,sCAAA;EACA,yCAAA;EACA,yCAAA;EACA,iBAAA;AA1BZ;AA6BI;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;AA3BN;AAmCM;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAjCR;AAmCQ;EACE,SAAA;AAjCV;AAmCU;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAjCZ;AAoCU;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAlCZ;AAoCY;EACE,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAlCd;AAoCc;EACE,mBAAA;EACA,cAAA;AAlChB;AAqCc;EACE,mBAAA;EACA,cAAA;AAnChB;AAsCc;EACE,mBAAA;EACA,cAAA;AApChB;AAuCc;EACE,mBAAA;EACA,cAAA;AArChB;AAyCY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;AAvCd;AA4CQ;EACE,aAAA;EACA,WAAA;AA1CV;AA4CU;EAUA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAnDV;AAoDU;EACE,+BAAA;EACA,YAAA;AAlDZ;AAwDM;EACE,mBAAA;AAtDR;AAwDQ;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;AAtDV;AA0DM;EACE,mBAAA;AAxDR;AA0DQ;EACE,sBAAA;AAxDV;AA0DU;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;AAxDZ;AA2DU;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAzDZ;AA2DY;EACE,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAzDd;AA2Dc;EACE,mBAAA;AAzDhB;AAgEM;EACE,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AA9DR;AAgEQ;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AA9DV;AAsEE;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AApEF;AAuEE;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AArEJ;AAyEE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EAKA,gBAAA;EAGA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EAGA,yBAAA;EACA,2BAAA;AA7EJ;AAgFI;EACE,yBAAA;AA9EN;AAkFI;EACE,wDAAA;EACA,uBAAA;AAhFN;AAoFI;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAlFN","sourcesContent":[".label-main-div-header {\r\n  position: relative;\r\n  z-index: 1;\r\n\r\n  .filter-group label{\r\n    display: block;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .view-toggle-wrapper {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    align-items: center;\r\n\r\n    .view-toggle-btn {\r\n      display: flex;\r\n      align-items: center;\r\n      padding: 0.3rem 0.6rem;\r\n      font-size: 0.9rem;\r\n      background-color: transparent;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 6px;\r\n      cursor: pointer;\r\n      transition: all 0.2s;\r\n\r\n      svg {\r\n        font-size: 1rem;\r\n      }\r\n\r\n      &.active {\r\n        background-color: #e5e7eb;\r\n      }\r\n\r\n      &:hover {\r\n        background-color: #f3f4f6;\r\n      }\r\n    }\r\n  }\r\n  .label-mod{\r\n    display: flex;\r\n    gap: 8px;\r\n  }\r\n\r\n\r\n  .labels-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    background-color: var(--card-bg);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 0.5rem;\r\n    overflow: hidden;\r\n    font-size: 0.95rem;\r\n    box-shadow: 0 2px 6px var(--shadow-light);\r\n\r\n    thead {\r\n      background-color: #f1f5f9;\r\n\r\n      th {\r\n        text-align: left;\r\n        padding: 1rem;\r\n        color: #111827;\r\n        // border: 1px solid #ddd;\r\n      }\r\n    }\r\n\r\n    tbody {\r\n      tr {\r\n        transition: background-color 0.2s ease;\r\n\r\n        &:hover {\r\n          background-color: #f9fafb;\r\n        }\r\n\r\n        td {\r\n          padding: 0.9rem 1rem;\r\n          // border: 1px solid #ddd;\r\n        }\r\n\r\n        td:last-child {\r\n          white-space: nowrap;\r\n\r\n          button {\r\n            margin-right: 0.5rem;\r\n            padding: 0.3rem 0.6rem;\r\n            font-size: 0.85rem;\r\n            border: 1px solid var(--border-color);\r\n            border-radius: 4px;\r\n            cursor: pointer;\r\n            // background-color: #2563eb;\r\n            // color: white;\r\n\r\n            // &:last-child {\r\n            //   background-color: #dc2626; // red for delete\r\n            // }\r\n\r\n            &:hover {\r\n              opacity: 0.9;\r\n              background-color: #fef9fa;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .label-container {\r\n    margin-top: 1rem;\r\n    display: grid;\r\n    gap: 1rem;\r\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n    background-color: #f8f9fa;\r\n    padding: 1rem;\r\n    grid-auto-rows: 1fr;\r\n\r\n    \r\n    .no-labels-found{\r\n      text-align: center;\r\n            font-size: 1.1rem;\r\n            color: var(--text-color-medium);\r\n            padding: calc(var(--spacing-unit) * 3) calc(var(--spacing-unit) * 2);\r\n            background: var(--card-bg);\r\n            border-radius: 0.75rem;\r\n            border: 1px dashed var(--border-color);\r\n            box-shadow: 0 2px 5px var(--shadow-light);\r\n            margin-top: calc(var(--spacing-unit) * 2);\r\n            grid-column: 1 / -1;\r\n    }\r\n\r\n    .label-card {\r\n      background: white;\r\n      border-radius: 12px;\r\n      padding: 1.5rem;\r\n      border: 1px solid #e2e8f0;\r\n      transition: all 0.2s;\r\n      cursor: pointer;\r\n      display: flex;\r\n      flex-direction: column;\r\n\r\n      // &:hover {\r\n      //   transform: translateY(-2px);\r\n      //   box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\r\n      //   border-color: #3b82f6;\r\n      // }\r\n\r\n      .label-card-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: flex-start;\r\n        margin-bottom: 1rem;\r\n\r\n        .label-title-section {\r\n          flex: 1;\r\n\r\n          .label-name {\r\n            font-size: 1.125rem;\r\n            font-weight: 600;\r\n            color: #1e293b;\r\n            margin: 0 0 0.5rem 0;\r\n          }\r\n\r\n          .label-meta {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 0.75rem;\r\n\r\n            .priority-badge {\r\n              padding: 0.25rem 0.75rem;\r\n              border-radius: 20px;\r\n              font-size: 0.75rem;\r\n              font-weight: 600;\r\n              text-transform: uppercase;\r\n\r\n              &.priority-high {\r\n                background: #fef2f2;\r\n                color: #dc2626;\r\n              }\r\n\r\n              &.priority-medium {\r\n                background: #fef3c7;\r\n                color: #d97706;\r\n              }\r\n\r\n              &.priority-low {\r\n                background: #f0fdf4;\r\n                color: #16a34a;\r\n              }\r\n\r\n              &.priority-unknown {\r\n                background: #f3f4f6;\r\n                color: #6b7280;\r\n              }\r\n            }\r\n\r\n            .color-indicator {\r\n              width: 1rem;\r\n              height: 1rem;\r\n              border-radius: 50%;\r\n              border: 2px solid white;\r\n              box-shadow: 0 0 0 1px #e2e8f0;\r\n            }\r\n          }\r\n        }\r\n\r\n        .label-actions {\r\n          display: flex;\r\n          gap: 0.5rem;\r\n\r\n          .action-btn {\r\n            // width: 2rem;\r\n            // height: 2rem;\r\n            // border: none;\r\n            // border-radius: 15px;\r\n            // cursor: pointer;\r\n            // display: flex;\r\n            // align-items: center;\r\n            // justify-content: center;\r\n            // transition: all 0.2s;\r\n          margin-right: 0.5rem;\r\n          padding: 0.3rem 0.6rem;\r\n          font-size: 0.85rem;\r\n          border: none;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n          &:hover {\r\n            background: var(--container-bg);\r\n            opacity: 0.9;\r\n          }\r\n          }\r\n        }\r\n      }\r\n\r\n      .label-description {\r\n        margin-bottom: 1rem;\r\n\r\n        p {\r\n          color: #64748b;\r\n          font-size: 0.875rem;\r\n          line-height: 1.5;\r\n          margin: 0;\r\n        }\r\n      }\r\n\r\n      .label-court-info {\r\n        margin-bottom: 1rem;\r\n\r\n        .court-section {\r\n          margin-bottom: 0.75rem;\r\n\r\n          .court-label {\r\n            display: block;\r\n            font-size: 0.75rem;\r\n            font-weight: 600;\r\n            color: #374151;\r\n            margin-bottom: 0.5rem;\r\n            text-transform: uppercase;\r\n          }\r\n\r\n          .court-refs {\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            gap: 0.5rem;\r\n\r\n            .court-ref-chip {\r\n              background: #f1f5f9;\r\n              color: #1e293b;\r\n              padding: 0.25rem 0.5rem;\r\n              border-radius: 6px;\r\n              font-size: 0.75rem;\r\n              font-weight: 500;\r\n              cursor: pointer;\r\n              transition: all 0.2s;\r\n\r\n              &:hover {\r\n                background: #e2e8f0;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .label-footer {\r\n        padding-top: 1rem;\r\n        border-top: 1px solid #f1f5f9;\r\n        margin-top: auto;\r\n        min-height: 2rem;\r\n\r\n        .created-date {\r\n          color: #64748b;\r\n          font-size: 0.75rem;\r\n          line-height: 1.2;\r\n        }\r\n      }\r\n    }\r\n\r\n\r\n  }\r\n\r\n  .pagination-settings {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  padding: 7px 18px;\r\n  background-color: #E2E8F0;\r\n  border-radius: 6px;\r\n\r\n\r\n  label {\r\n    white-space: nowrap;\r\n    color: #1f2937;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n  }\r\n\r\n\r\n  #labelPerPageSelect {\r\n    border: none;\r\n    border-radius: 6px;\r\n    outline: none;\r\n    padding: 6px 32px 6px 12px;\r\n    background-color: white;\r\n    font-size: 14px;\r\n    color: #333;\r\n    cursor: pointer;\r\n    min-width: 70px;\r\n\r\n\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n\r\n\r\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23666'%3e%3cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 10px center;\r\n    background-size: 16px;\r\n\r\n\r\n    transition: all 0.2s ease;\r\n    box-shadow: none !important;\r\n\r\n\r\n    &:hover {\r\n      background-color: #fafafa;\r\n    }\r\n\r\n\r\n    &:focus {\r\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;\r\n      background-color: white;\r\n    }\r\n\r\n\r\n    option {\r\n      border: none !important;\r\n      outline: none;\r\n      padding: 4px 8px;\r\n    }\r\n  }\r\n}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
